(ns iris.posts.common
  (:require
   [clojure.string :as string]))

(defonce route-prefix "")

(defn agor-edit-url [ruid genus ws title]
  (let [ruid-enc  (js/encodeURIComponent ruid)
        title-enc (js/encodeURIComponent title)]
    (str js/agorBaseURL
         "#/view-entities;website=" ws
         ";genus=" genus
         ";q=title:" title-enc
         "/(side:edit/" ruid-enc ")")))

(defonce THREAD_POST_ID_RE_STR "([a-zA-Z0-9]{6,9})")
(defonce REPLY_POST_ID_RE_STR "([a-zA-Z0-9]{2,5})")

(defonce POST_ID_RE_STR (str "\\@" REPLY_POST_ID_RE_STR "\\+" THREAD_POST_ID_RE_STR))
(defonce POST_ID_RE (re-pattern POST_ID_RE_STR))

(defonce REF_HTAG_RE_STR "<a href=\"/h/(.+)\" class=\"ref htag\">")
(defonce REF_HTAG_RE (re-pattern REF_HTAG_RE_STR))

(defonce REF_FREF_RE_STR "<a href=\"(.+)\" title=\".+\" class=\"ref fref\">")
(defonce REF_FREF_RE (re-pattern REF_FREF_RE_STR))

(defonce REF_PREF_RE_STR (str "<a href=\"/p/" POST_ID_RE_STR "\" class=\"ref pref\">"))
(defonce REF_PREF_RE (re-pattern REF_PREF_RE_STR))

(defonce OLD_REF_PREF_RE_STR (str "<a href=\"/r/" THREAD_POST_ID_RE_STR "\\-" REPLY_POST_ID_RE_STR "\">"))

(defonce OLDER_REF_PREF_RE_STR (str "<a href=\"/r/" THREAD_POST_ID_RE_STR "\">"))

(defonce DESIRED-POST-FILTER-ORDER [:ws :cc :geo :ip :cookie :bfp :dfp :ua :mime :lang :thread :user :board])

(defn reorder-post-id [id]
  (string/replace id POST_ID_RE "$2#$1"))

(defn ruid-to-ahref [s]
  (when-not (string/blank? s)
    (string/replace s POST_ID_RE "<a href=\"/t/$2#$1\">@$1+$2</a>")))

(defn linkify-header [s]
  (string/replace s
                  #"/[a-zA-Z0-9\-]+\.[A-Z]{3}"
                  (fn [match]
                    (str "<a href=\"" match "\">" match "</a>"))))